// src/components/CalendarView.js
import React, { useState } from 'react';

import Icon from "../../components/em/Icon";
import PropTypes from 'prop-types';
import { localDateStr } from '../../utils/localDate';
import { formatHoursDuration } from '../../utils/duration';







const STATUS_COLORS = {
  present: '#ff7a00',
  'in-progress': '#1e90ff',
  leave: '#4caf50',
  absent: '#f44336',
  holiday: '#9c27b0'
};

const STATUS_LABELS = {
  present: 'Present',
  'in-progress': 'In Progress',
  leave: 'On Leave',
  absent: 'Absent — no attendance marked',
  holiday: 'Holiday',
};

const CalendarView = ({ data = [] }) => {
  /* ---------------------------
     STATE: MONTH & YEAR
  --------------------------- */
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth());

  /* ---------------------------
     MAP DATA BY DATE
  --------------------------- */
  const dataMap = {};
  data.forEach(d => {
    dataMap[d.date] = d;
  });

  /* ---------------------------
     MONTH CALCULATION
  --------------------------- */
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);

  const startWeekday = firstDay.getDay();
  const daysInMonth = lastDay.getDate();

  const cells = [];
  for (let i = 0; i < startWeekday; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) {
    cells.push(new Date(year, month, d));
  }

  const isToday = (d) =>
    d.toDateString() === new Date().toDateString();

  /* ---------------------------
     MONTH NAVIGATION
  --------------------------- */
  const goPrev = () => {
    if (month === 0) {
      setMonth(11);
      setYear(y => y - 1);
    } else {
      setMonth(m => m - 1);
    }
  };

  const goNext = () => {
    if (month === 11) {
      setMonth(0);
      setYear(y => y + 1);
    } else {
      setMonth(m => m + 1);
    }
  };

  /* ---------------------------
     RENDER
  --------------------------- */
  return (
    <div className="month-cal">


<div className="title-btns">
  <div className="icn-subtit">
    <span className="icon-wrap"><Icon name="clock" color="#f54b01" /></span>
    <h3>Monthly Calendar</h3>
  </div>
  <div className="btn-wrap"></div>
</div>


      {/* HEADER */}
      <div className="calendar-header">
        <button onClick={goPrev} className="nav-btn">◀</button>
        <h4 className="calendar-title">
          {new Date(year, month).toLocaleString('en-US', {
            month: 'long',
            year: 'numeric'
          })}
        </h4>
        <button onClick={goNext} className="nav-btn">▶</button>
      </div>

      {/* CALENDAR GRID */}
      <div className="main-calendar">

        {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(h => (
          <div key={h} className="cal-title">{h}</div>
        ))}

        {cells.map((dateObj, idx) => {
          if (!dateObj) {
            return <div key={idx} className="cal-date empty"></div>;
          }

          // MUST be the local day: `cells` holds `new Date(year, month, d)` =
          // LOCAL midnight, so toISOString() here returned the previous UTC day
          // in any zone ahead of UTC (IST) and painted every record one cell to
          // the right — attendance marked on the 13th showed up on the 14th.
          const key = localDateStr(dateObj);
          const record = dataMap[key];
          const status = record?.status;
          const hours = record?.working_hours;

          return (
            <div
              key={idx}
              className={`cal-date cal-fill ${isToday(dateObj) ? 'today' : ''}`}
            >
              <div className="cal-inner">
                <div className="cal-day">{dateObj.getDate()}</div>

                {status && (
                  <div
                    className="attd-mark"
                    // Names the marker on hover — a bare coloured bar makes the
                    // reader match it against the legend. `label` carries the
                    // holiday's name when the API knows it.
                    title={record?.label || STATUS_LABELS[status] || status}
                    style={{
                      background: STATUS_COLORS[status] || '#e0e0e0'
                    }}
                  />
                )}

                {hours != null && (
                  <div className="cal-hours">{formatHoursDuration(hours)}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* LEGEND */}
      <div className="calendar-mark">
        <Legend color="#ff7a00" label="Present" />
        <Legend color="#1e90ff" label="In Progress" />
        <Legend color="#4caf50" label="On Leave" />
        <Legend color="#f44336" label="Absent" />
        <Legend color="#9c27b0" label="Holiday" />
      </div>
    </div>
  );
};

const Legend = ({ color, label }) => (
  <div className="legend-item">
    <span className="legend-dot" style={{ background: color }} />
    <p>{label}</p>
  </div>
);

export default CalendarView;
